import React, { FC } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';

import List from 'vibo-ui/List';
import LoadingOverlay from 'components/common/LoadingOverlay';
import PlaylistCard from 'components/songIdeas/SongIdeasList/PlaylistCard';
import NoIdeasSearchResults from 'components/emptyStates/NoIdeasSearchResults';

import { DEFAULT_GRID_PROPS } from 'components/common/Dnd/constants';
import { CARD_GAP_SM, CARD_GAP_LG, CARD_COLS_COUNT } from './constants';

import { SongIdeasCardViewComponentProps } from './interfaces';

import useStyles from './style';

const SongIdeasCardsViewComponent: FC<SongIdeasCardViewComponentProps> = ({
  loadMore,
  totalCount,
  className,
  onPlaylistClick,
  renderPlaylistCard,
  gridProps,
  scrollId = 'song-finder-scroll',
  emptyStateText = 'letsFindSongsForEvent',
  header = null,
  playlists = [],
  loading = false,
  ...rest
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <>
      {!!header ? <div className={classNames('top', classes.header)}>{header}</div> : null}
      {loading && !totalCount ? <LoadingOverlay /> : null}
      {!loading && !totalCount ? (
        <NoIdeasSearchResults>{t(emptyStateText)}</NoIdeasSearchResults>
      ) : (
        <List<SongIdeasPreview>
          data={playlists}
          renderItem={playlist =>
            !!renderPlaylistCard ? (
              renderPlaylistCard(playlist)
            ) : (
              <PlaylistCard
                playlist={playlist}
                onClick={() => {
                  onPlaylistClick?.(playlist);
                }}
                key={`playlist-search-card-${playlist._id}`}
              />
            )
          }
          className={classNames('content-fade-in', className, {
            ready: !!playlists.length,
          })}
          gridProps={
            gridProps ?? {
              columns: [CARD_COLS_COUNT, CARD_COLS_COUNT],
              gaps: [CARD_GAP_SM, CARD_GAP_LG],
            }
          }
          scrollId={scrollId}
          loadMore={loadMore}
          {...DEFAULT_GRID_PROPS}
          {...rest}
        />
      )}
    </>
  );
};

export default SongIdeasCardsViewComponent;
